import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css';

import App from './App.vue';
import router, { registerSessionExpiredHook } from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.prerender-pi-dark',
    },
  },
});
// PrimeVue services for global Toast / ConfirmDialog usage in Cache Manager.
app.use(ToastService);
app.use(ConfirmationService);

// Wire 401 → auth.markExpired() + redirect to /login?expired=1.
// Registered after Pinia + router are installed so the hook can resolve
// useAuthStore() lazily on each invocation.
registerSessionExpiredHook();

app.mount('#app');
